import { Card, CardBody, CardHeader, CardTitle, Text } from "@govlaunch/web";
import { BoxProps } from "@govlaunch/web/src/box/Box";
import React from "react";
import { FormattedMessage } from "react-intl";
import { IProductFieldsFragment } from "../fragments/__generated__/ProductFieldsFragment.generated";
import { ISolutionStatus } from "../graphql/types";

interface IProductSolutionsCardProps extends BoxProps {
  product: IProductFieldsFragment;
}

export default function ProductSolutionsCard({ product }: IProductSolutionsCardProps) {
  const solutions = product.solutions || [];

  if (solutions.length === 0) {
    return null;
  }

  return (
    <Card mt={4}>
      <CardHeader>
        <CardTitle>
          <FormattedMessage defaultMessage="Service & Product Integrations" id="wKRmA8" />
        </CardTitle>
      </CardHeader>

      <CardBody>
        <ul css={{ listStyleType: "none" }}>
          {solutions
            .filter(solution => solution.status === ISolutionStatus.Approved)
            .map(solution => {
              return (
                <li key={solution._id}>
                  <Text fontSize="sm" as="span" clamp={1}>
                    {solution.name}
                  </Text>
                </li>
              );
            })}
        </ul>
      </CardBody>
    </Card>
  );
}
